import { render, staticRenderFns } from "./view-photos.vue?vue&type=template&id=4a89c4cb&scoped=true&lang=pug"
import script from "./view-photos.vue?vue&type=script&lang=js"
export * from "./view-photos.vue?vue&type=script&lang=js"
import style0 from "./view-photos.vue?vue&type=style&index=0&id=4a89c4cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a89c4cb",
  null
  
)

export default component.exports